import script from "./AddCarousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddCarousel.vue?vue&type=script&lang=ts&setup=true"

import "./AddCarousel.vue?vue&type=style&index=0&id=f8e036c8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e036c8"]])

export default __exports__